const AbstractRepository = require('@/lib/Repositories/AbstractRepository');
const DataStoreNames = require('@/lib/DataStores/DataStoreNames');
const Privileges = require('./Privileges');

class PrivilegesRepository extends AbstractRepository {
    /**
     * @param {DataStore} dataStore
     * @param {Hydrator} hydrator
     * @param {SyncStateManager} syncStateManager
     * @param privilegesResource
     */
    constructor(
        dataStore,
        hydrator,
        syncStateManager,
        privilegesResource
    ) {
        super(dataStore, hydrator, syncStateManager);

        this.privilegesResource = privilegesResource;
    }

    getEntityClass() {
        return Privileges;
    }

    getEntityName() {
        return 'Privileges';
    }

    getTableName() {
        return DataStoreNames.PRIVILEGES;
    }

    getResource() {
        return this.privilegesResource;
    }

    /**
     * @return {Promise<Privileges[]>}
     */
    findAll() {
        return super.findAll();
    }
}

module.exports = PrivilegesRepository;
